import { GdprPage } from "@/features/hca-public";
import { PublicShellWithDiagnoza } from "@/route-helpers/public-shell-with-diagnoza";
import { usePageMeta } from "@/shared/seo/use-page-meta";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/gdpr")({
  component: GdprRoute,
});

function GdprRoute() {
  usePageMeta({
    title: "Ochrana osobních údajů",
    description: "Zásady zpracování a ochrany osobních údajů (GDPR) společnosti HCA Moravia.",
    path: "/gdpr",
  });
  return (
    <PublicShellWithDiagnoza>
      <GdprPage />
    </PublicShellWithDiagnoza>
  );
}
